import { render, staticRenderFns } from "./createFuwuOrder.vue?vue&type=template&id=2cef0ef6&scoped=true"
import script from "./createFuwuOrder.vue?vue&type=script&lang=js"
export * from "./createFuwuOrder.vue?vue&type=script&lang=js"
import style0 from "./createFuwuOrder.vue?vue&type=style&index=0&id=2cef0ef6&prod&scoped=true&lang=css"
import style1 from "./createFuwuOrder.vue?vue&type=style&index=1&id=2cef0ef6&prod&lang=css"
import style2 from "./createFuwuOrder.vue?vue&type=style&index=2&id=2cef0ef6&prod&scoped=true&lang=scss"
import style3 from "./createFuwuOrder.vue?vue&type=style&index=3&id=2cef0ef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef0ef6",
  null
  
)

export default component.exports